import { graphql } from 'react-apollo';
import { getClientEnvironmentDetails } from '@sm/utils';
import { errorHandler as clientErrorHandler } from '../../../helpers/errorHandler';
import SaveTreatmentMutation from './SaveTreatment.graphql';

/**
 * If the user is LO and we have values from the Svc,
 * we can set a cookie for experimentsvc to injest
 * @param {Object} cookie
 * @return {null}
 */
var createCookie = function createCookie(cookie) {
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  // no need to create a cookie if there isn't a cookie to create
  if (cookie.success === false || !cookie.name) return null;
  var name = cookie.name,
    maxAge = cookie.maxAge,
    assignments = cookie.assignments;
  if (isBrowser) {
    var host = window.location.host;
    var domain = host.replace(/^[^.]+\./g, '');
    document.cookie = "".concat(name, "=").concat(assignments, "; max-age=").concat(maxAge, "; path=/; domain=").concat(domain);
  }
  return null;
};

/**
 * Component to display a treatment
 * @param {String} when
 * @param {Object} treatments
 * @param {Boolean} control
 * @param {Function|Object} children
 * @returns {*}
 */
var Treatment = function Treatment(_ref) {
  var when = _ref.when,
    control = _ref.control,
    children = _ref.children,
    treatments = _ref.treatments,
    _ref$mutate = _ref.mutate,
    mutate = _ref$mutate === void 0 ? function () {
      return null;
    } : _ref$mutate;
  var childElement = typeof children === 'function' ? children() : children;
  var allTreatments = Object.keys(treatments);

  // If experiments fails, or the user hasn't been assigned and experiment show the control.
  if (allTreatments.length === 0 && control) {
    return childElement;
  }

  // if our treatment exists in the object
  if (allTreatments.length) {
    if (treatments[when] && treatments[when].treatmentName) {
      // send the data back to experiments that we are showing this treatment
      var _treatments$when = treatments[when],
        treatmentId = _treatments$when.treatmentId,
        experimentId = _treatments$when.experimentId,
        treatmentName = _treatments$when.treatmentName,
        experimentName = _treatments$when.experimentName,
        assignmentType = _treatments$when.assignmentType;
      mutate({
        variables: {
          input: {
            treatmentId: treatmentId,
            treatmentName: treatmentName,
            experimentId: experimentId,
            experimentName: experimentName,
            assignmentType: assignmentType
          }
        }
      }).then(function (_ref2) {
        var data = _ref2.data;
        if (data && data.saveExperimentTreatment) createCookie(data.saveExperimentTreatment);
      }).catch(function (e) {
        return clientErrorHandler.logError(e, 'Unable to save experiment treatment');
      });
      // Let's return the child element without waiting for the mutation as the
      // mutation doesn't really impact the children.
      return childElement;
    }
  }
  return null;
};
export default graphql(SaveTreatmentMutation)(Treatment);
//# sourceMappingURL=index.js.map